import moment from 'moment';

function directive(getSize, $location, generateId, timeFormat, $window) {
    return {
        link: function ($scope, element, attrs, dcCrtl) {
            // set hight and width ratios
            var size = getSize(element, 'linechart');
            var width = size.width;
            var height = size.height;
            if (attrs.type === "services") {
                height = height/2;
            }

            // bind the window object to the local w variable in scope
            $scope.page.w = angular.element($window);

            var dimension, group, toggleValues, networkmap; // set our default vairables
            var lineChartOn = true;

            // initalize
            $scope.$on('init', function (event, lineChartIdentifiers) {
                if (lineChartIdentifiers.id !== attrs.uid) { return }
                if (typeof $scope.main.dataObjects[lineChartIdentifiers.key] === 'undefined') { return } // if its not in our dc object, ignore
                $scope.main.dataObjects[lineChartIdentifiers.key].launched = true;
                let uid = lineChartIdentifiers.id;
                let key = lineChartIdentifiers.key;
                let interval = 3600; // 3600 = hour, 600 = 10 mins
                if ($scope.main.dataObjects[key].settings !== null) {
                    if ($scope.main.dataObjects[key].settings.interval) {
                        interval = $scope.main.dataObjects[key].settings.interval
                    }
                    // set variables that are
                    if (typeof $scope.main.dataObjects[key].settings.settings.toggleValues !== "undefined") {
                        toggleValues = $scope.main.dataObjects[key].settings.settings.toggleValues;
                    }
                    if (typeof $scope.main.dataObjects[key].settings.settings.networkmap !== "undefined") {
                        networkmap = $scope.main.dataObjects[key].settings.settings.networkmap;
                    }
                }
                var toggleVal;
                if (!$scope.page.settings.get('toggleVal')) {
                    toggleVal = false;
                    $scope.togVal = 1;
                    $scope.byteOffset = 7;
                } else {
                    toggleVal = $scope.page.settings.get('toggleVal')
                    $scope.byteOffset = 1;
                    $scope.togVal = 1048576;
                    if ($scope.page.settings.get('toggleVal') === "KB") {
                        $scope.byteOffset = 2.5;
                        $scope.togVal = 1024;
                    }
                }

                // load saved variable
                var stacked;
                if (!$scope.page.settings.get('lineChartStacked')) {
                    stacked = false;
                } else {
                    stacked = $scope.page.settings.get('lineChartStacked');
                }

                // load saved variable
                var log;
                if (!$scope.page.settings.get('toggleLog')) {
                    log = false;
                } else {
                    log = $scope.page.settings.get('toggleLog');
                }

                let start, end, bstart, bend;

                var margin = {
                    top: 10,
                    right: 15,
                    bottom: 10,
                    left: 40
                };

                let difference = 0 , differenceOld = 0;
                width = width - margin.left - margin.right,
                height = height - margin.top - margin.bottom;

                var value = 0, x, y, hours;
                var areas = [];
                var lines = [];

                var xAxis;
                var yAxis;
                var lc = [];
                var data = [];
                var blankData = {};

                var lineCombinations = [];
                var outterDiv = d3.select("#"+attrs.id).append("div");

                let initialTime = $scope.main.getTime();
                bstart = initialTime.start;
                bend = initialTime.end;
                function setupData() {
                    let t = $scope.main.getTime();
                    start = t.start;
                    end = t.end;
                    var newData;
                    hours = ((( getHour(end) - getHour(start) ) / interval ) / 1000 ) +1;
                    data = [];
                    lineCombinations = [];
                    if ($scope.main.dataObjects[key].group.top(Infinity).length === 0) {
                        return;
                    }
                    data = angular.copy($scope.main.dataObjects[key].group.top(Infinity));
                    for (var d in data[0].value) {
                        lineCombinations.push(d);
                        blankData[d] = 0;
                    }
                    data.sort(orderChart);

                    for (var j=0; j<=hours; j++) {
                        if (data[j]) {
                            if (Number(data[j].key) !== Number(getHour(Number(start)+(j*interval)))) {
                                data.splice(j, 0, { key: getHour(Number(start)+(j*interval)), value: blankData });
                            }
                        } else {
                            data.splice(j, 0, { key: getHour(Number(start)+(j*interval)), value: blankData });
                        }
                    }
                }
                if ($scope.main.dataObjects[key].group) {
                    setupData();
                }

                // SETUP LOG / LINEAR button for linechart
                var checklog = outterDiv.append("svg")
                    .attr("class", "toggleLog")
                    .attr("height", 24).attr("width", 24)
                    .on("click", function (d) {
                        if (log) {
                            log = false;
                        } else {
                            log = true;
                        }
                        // update settings
                        $scope.page.settings.set('toggleLog', log).then(function () {
                            setWidthHeight(width, height);
                            redrawAxis();
                            redraw();
                            checkLogValue();
                        })
                    })
                    .append("text")
                        .attr("class", "checkboxLog")
                        .attr("y", "16")
                        .attr("font-size", "10")
                        .attr("fill", "#000")
                        .attr("font-family", "ubuntu")
                        .attr("font-weight", "bold")
                    checkLogValue();

                var index;
                // SETUP stacked or not stacked button for linechart
                if (lineCombinations.length > 1) {
                    var checkbox = outterDiv.append("svg")
                        .attr("class", "toggleStacked")
                        .attr("height", 24).attr("width", 24)
                        .on("click", function (d) {
                            // save it if false
                            if (stacked) {
                                stacked = false;
                            } else {
                                // delete value if true
                                stacked = true;
                            }
                            $scope.page.settings.set('lineChartStacked', stacked).then(function () {
                                redrawAxis();
                                redraw();
                                d3.select(".checkboxStacked")
                                    .attr("d", function () {
                                        if (stacked) {
                                            return "M14,0l5.31,5.86-0.74.67L14.16,1.72,9.93,9.57,5.53,6.77,0.45,9.31,0,8.41,5.59,5.62l4,2.53Zm0.42,9.53,4.86,4.29-0.66.75-4.2-3.71-4.57,4L5.53,12.1,0.45,14.64,0,13.75,5.59,11,9.7,13.57Z";
                                        }
                                        return "M20.1,7.78l0.2,1-5.23,1L13.24,8.29,10.59,14,6.15,10.85,1.09,13.38l-0.45-.89,5.6-2.8,3.94,2.82,2.25-4.89L9.17,4.9,4.72,8,0,0.54,0.84,0,5,6.56,9.23,3.64l3.65,3L14.62,2.9,19.3,0.49l0.46,0.89L15.39,3.63,13.67,7.35l1.66,1.38Z";
                                    })
                            })
                        })
                        .append("path")
                        .attr("class", "checkboxStacked")
                        .attr("fill", "#231F20")
                        .attr("transform", "translate(2,5)")
                        .attr("d", function () {
                            if (stacked) {
                                return "M14,0l5.31,5.86-0.74.67L14.16,1.72,9.93,9.57,5.53,6.77,0.45,9.31,0,8.41,5.59,5.62l4,2.53Zm0.42,9.53,4.86,4.29-0.66.75-4.2-3.71-4.57,4L5.53,12.1,0.45,14.64,0,13.75,5.59,11,9.7,13.57Z";
                            }
                            return "M20.1,7.78l0.2,1-5.23,1L13.24,8.29,10.59,14,6.15,10.85,1.09,13.38l-0.45-.89,5.6-2.8,3.94,2.82,2.25-4.89L9.17,4.9,4.72,8,0,0.54,0.84,0,5,6.56,9.23,3.64l3.65,3L14.62,2.9,19.3,0.49l0.46,0.89L15.39,3.63,13.67,7.35l1.66,1.38Z";
                        });
                }

                // SETUP toggle button between bytes, KB, MB for linechart
                if ((toggleValues) && (typeof toggleValues !== "undefined")) {
                    var valueToggle = outterDiv.append("svg")
                        .attr("class", "toggleLineValue")
                        .attr("height", 24).attr("width", 24)
                        .on("click", function () {
                            // save it if false
                            let toggle;
                            if ($scope.page.settings.get('toggleVal') === "KB") {
                                toggle = "MB";
                                $scope.togVal = 1048576;
                                $scope.byteOffset = 1;
                            } else if ($scope.page.settings.get('toggleVal') === "MB") {
                                toggle = false;
                                $scope.togVal = 1;
                                $scope.byteOffset = 7;
                            } else {
                                toggle = "KB";
                                $scope.togVal = 1024;
                                $scope.byteOffset = 2.5;
                            }
                            // update settings
                            $scope.page.settings.set('toggleVal', toggle).then(function () {
                                setupData();
                                redrawAxis();
                                redraw();
                                checkBoxValue()
                            })
                        })
                        .append("text")
                        .attr("class", "checkboxValue")
                        .attr("y", "17")
                        .attr("font-size", "14")
                        .attr("fill", "#000")
                        .attr("font-family", "ubuntu")
                        .attr("font-weight", "bold")
                    checkBoxValue();
                }

                function checkLogValue() {
                    d3.select(".checkboxLog").attr("x", function () {
                        if (log) {
                            return 2;
                        }
                        return 4;
                    }).text(function (d) {
                        if (log) {
                            return "LOG";
                        }
                        return "LIN";
                    })
                }

                function checkBoxValue() {
                    d3.select(".checkboxValue").attr("x", function (d) {return $scope.byteOffset;})
                    .text(function (d) {
                        if (!$scope.page.settings.get('toggleVal')) {
                            return "B";
                        } else {
                            return $scope.page.settings.get('toggleVal');
                        }
                    })
                }

                var svg = outterDiv.append("svg");

                function setWidthHeight(w, h) {
                    svg.attr("width",w+margin.left+margin.right).attr("height",h+margin.top+margin.bottom+20);
                    x = d3.time.scale().range([0, w]);
                    if (log) {
                        y = d3.scale.log().clamp(true).range([h, 0]).nice();
                    } else {
                        y = d3.scale.linear().range([h, 0]).nice();
                    }
                }
                setWidthHeight(width, height);

                function orderChart(a, b) {
                    if (a.key < b.key) { return -1; }
                    if (a.key > b.key) { return 1; }
                    return 0;
                }

                // var superscript = "⁰¹²³⁴⁵⁶⁷⁸⁹",
                // formatPower = function (d) { return (d + "").split("").map(function (c) { return superscript[c]; }).join(""); };
                var numberFormat = d3.format(",.2r");
                var expFormat = d3.format(".1e");
                function logFormat(d) {
                    var x = Math.log(d) / Math.log(10) + 1e-6;
                    if (d >= 1000) {
                        if (d === max) {
                            return expFormat(d)
                        }
                    }
                    if (d === max) {
                        return numberFormat(d)
                    }
                    if (d === 0.9) {
                        return numberFormat(0)
                    }
                }
                function regFormat(d) {
                    if (d === max) {
                        if (d >= 1000) {
                            return expFormat(d)
                        }
                        return numberFormat(d)
                    }
                    if (d === 0) {
                    return numberFormat(d);
                    }
                }

                var brush = d3.svg.brush().x(x).on("brush", brushed);

                function setUpXAxis() {
                    x.domain([getHour(start), getHour(end, true)]);
                    return d3.svg.axis()
                        .scale(x)
                        .tickSize(5)
                        .orient("bottom");
                }
                let max = 1;
                function setUpYAxis() {
                    let val = 0;
                    let format = regFormat;
                    if (log) {
                        val = 0.9;
                        format = logFormat;
                    }
                    max = d3.max(data, function (d) {
                            value = 0;
                            for (var i = lineCombinations.length-1; i>=0; i--) {
                                if (typeof d.value[lineCombinations[i]] !== "undefined") {
                                    if ((toggleValues) && (typeof toggleValues !== "undefined")) {
                                        if (stacked) {
                                            value += (d.value[lineCombinations[i]]/$scope.togVal)
                                        } else {
                                            if (value < d.value[lineCombinations[i]]/$scope.togVal) {
                                                value = d.value[lineCombinations[i]]/$scope.togVal;
                                            }
                                        }
                                    } else {
                                        if (stacked) {
                                            value += d.value[lineCombinations[i]]
                                        } else {
                                            if (value < d.value[lineCombinations[i]]) {
                                                value = d.value[lineCombinations[i]];
                                            }
                                        }
                                    }
                                }
                            }
                            return value+1;
                        })
                    if (!max) {
                        max = 1;
                    }
                    y.domain([val, max ]);
                    return d3.svg.axis()
                        .scale(y)
                        .tickSize(0)
                        .tickFormat(format)
                        .tickValues( y.ticks( 10 ).concat( y.domain() ) )
                        .orient("left");
                }

                var color = function (value) {
                    if (value) {
                        value = value.toLowerCase();
                    }
                    if (value === "guarded") {
                        return "#377FC7";
                    } else if (value === "elevated") {
                        return "#F5D800";
                    } else if (value === "high") {
                        return "#F88B12";
                    } else if (value === "severe") {
                        return "#FF3131";
                    } else if ((value === "bytes_to") || (value === "kb_to") || (value === "mb_to") || (value === "bytes_toV2") || (value === "kb_toV2") || (value === "mb_toV2")) {
                        return "#045859";
                    } else if ((value === "bytes_from") || (value === "kb_from") || (value === "mb_from") || (value === "bytes_fromV2") || (value === "kb_fromV2") || (value === "mb_fromV2")) {
                        return "#08B5B8";
                    } else if ((value === "bytes_toV3") || (value === "kb_toV3") || (value === "mb_toV3")) {
                        return "#112F41";
                    } else if ((value === "bytes_fromV3") || (value === "kb_fromV3") || (value === "mb_fromV3")) {
                        return "#3FA8FF";
                    } else if (value === "conn_in") {
                        return "#34D4FF";
                    } else if (value === "conn_out") {
                        return "#009426";
                    } else if (value === "stealth_in") {
                        return "#C43C00";
                    } else if (value === "stealth_out") {
                        return "#C40600";
                    } else if (value === "other") {
                        return "#000";
                    } else {
                        return "#112F41";
                    }
                };

                function redrawAxis() {
                    xAxis = setUpXAxis();
                    yAxis = setUpYAxis();
                    svg.selectAll(".grid").remove();
                    svg.selectAll(".axis").remove();
                    svg.insert("g", ".lc")
                        .attr("class", "grid horizontal")
                        .attr("transform", "translate("+margin.left+"," + (height+margin.top)+ ")")
                        .call(setUpXAxis().tickSize(-height, 0, 0).ticks(24).tickFormat(""));

                    svg.insert("g", ".lc")
                        .attr("class", "grid vertical")
                        .attr("transform", "translate("+margin.left+","+margin.top+")")
                        .call(setUpYAxis().tickSize(-width, 0, 0).ticks(10).tickFormat(""));

                    svg.insert("g", ".lc")
                        .attr("class", "x axis")
                        .attr("stroke-width","1")
                        .attr("transform", "translate("+margin.left+"," + (height+margin.top)+ ")")
                        .call(xAxis);

                    svg.insert("g", ".lc")
                        .attr("class", "y axis")
                        .attr("stroke-width","1")
                        .attr("transform", "translate("+margin.left+","+margin.top+")")
                        .call(yAxis);
                }
                redrawAxis();

                let graph = svg.append("g").attr("class", "lc").attr("width", width)
                    .attr("transform", "translate("+(margin.left+1)+","+(margin.top-1)+")");

                let brushDiv = svg.append("g")
                    .attr("class", "brush")
                    .attr("transform", "translate("+(margin.left+1)+","+(margin.top)+")")
                    .call(brush)
                let brushDivRects = brushDiv.selectAll("rect")
                        .attr("y", 0)
                        .attr("height", height);
                let brushExtent = brushDiv.append('rect').attr("class", "timeBrush");

                function findYValue(a, b, y1) {
                    value = 0;
                    if ((toggleValues) && (typeof toggleValues !== "undefined")) {
                        if (stacked) {
                            for (var j = 0; j<= b; j++) {
                                if (typeof a.value[lineCombinations[j]] !== undefined) {
                                    value += (a.value[lineCombinations[j]]/$scope.togVal)
                                }
                            }
                        } else if (y1 === "y0") {
                            value = (a.value[lineCombinations[b+1]]/$scope.togVal)
                        } else if (y1 === "y") {
                            value = (a.value[lineCombinations[b]]/$scope.togVal)
                        }
                    } else {
                        if (stacked) {
                            for (var j = 0; j<= b; j++) {
                                if (typeof a.value[lineCombinations[j]] !== undefined) {
                                    value += a.value[lineCombinations[j]]
                                }
                            }
                        } else if (y1 === "y0") {
                            value = a.value[lineCombinations[b+1]];
                        } else if (y1 === "y") {
                            if (typeof a.value[lineCombinations[b]] === "undefined") {

                            }
                            value = a.value[lineCombinations[b]];
                        }
                    }
                    return y(value);
                }

                var colors;
                if (typeof $scope.page.color !== "undefined") {
                    colors = $scope.page.color;
                } else {
                    colors = color;
                }

                function redraw() {
                    areas = [];
                    lines = [];
                    for (var i = 0, len = lineCombinations.length; i < len; i++) {
                        areas[i] = d3.svg.area()
                            .interpolate("linear")
                            .x(function (d) { if (isNaN(x(d.key))) {return 0} return x(d.key); })
                            .y0(function (d) {return findYValue(d, i-1, "y0");})
                            .y1(function (d) {return findYValue(d, i);});

                        lines[i] = d3.svg.line()
                            .interpolate("linear")
                            .x(function (d) { if (isNaN(x(d.key))) {return 0} return x(d.key); })
                            .y(function (d) { return findYValue(d, i, "y"); });
                    }
                    for (var i = 0, len = lineCombinations.length; i < len; i++) {
                        if (typeof lc[i] === "undefined") {
                            lc[i] = graph.append("g")
                                .attr("width", width)
                                .attr("class", 'lc'+lineCombinations[i].replace(/((?:\W))/g,""));

                            lc[i].append("path")
                                .attr("class", "area "+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))
                                .attr("fill", colors(lineCombinations[i]))
                                .datum(data)
                                .attr("d", areas[i])
                                .style("opacity", "0.3");

                            lc[i].append("path")
                                .attr("class", "lineChartline "+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))
                                .attr("stroke", colors(lineCombinations[i]))
                                .datum(data)
                                .attr("d", lines[i]);
                        } else {
                            if (d3.select(".area."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))[0][0]) {
                                d3.select(".area."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))
                                    .datum(data)
                                    .attr("d", d3.select(".area."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))[0][0].attributes.d.nodeValue)
                                    .transition()
                                    .duration(500)
                                    .attr("d", areas[i])
                            } else {
                                d3.select(".area."+lineCombinations[i])
                                    .datum(data)
                                    .attr("d", areas[i])
                            }

                            if (d3.select(".lineChartline."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))[0][0]) {
                                d3.select(".lineChartline."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))
                                    .datum(data)
                                    .attr("d", d3.select(".lineChartline."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))[0][0].attributes.d.nodeValue)
                                    .transition()
                                    .duration(500)
                                    .attr("d", lines[i])
                            } else {
                                d3.select(".lineChartline."+'lc'+lineCombinations[i].replace(/((?:\W))/g,""))
                                    .datum(data)
                                    .attr("d", lines[i])
                            }

                            for (var ld in d3.selectAll(".lineDots."+'lc'+lineCombinations[i].replace(/((?:\W))/g,"")).data(data)[0]) {
                                d3.select(d3.selectAll(".lineDots."+'lc'+lineCombinations[i].replace(/((?:\W))/g,"")).data(data)[0][ld])
                                    .transition()
                                    .duration(500)
                                    .attr("cx", function (d) {
                                        if (typeof d !== "undefined") {
                                            if (isNaN(x(d.key))) {
                                                return 0
                                            }
                                            return x(d.key)
                                        }
                                    })
                                    .attr("cy", function (d) {
                                        if (typeof d !== "undefined") {
                                            return findYValue(d, i, "y");
                                        }
                                    })
                                    .attr("r", function (d) {
                                        if (typeof d !== "undefined") {
                                            if (d.value[lineCombinations[i]] === 0) {
                                                return 0
                                            }
                                            return 2.5
                                        }
                                    });
                            }
                        }
                    }
                }
                redraw();

                function unhighlight() {
                    for (var i = 0, len = lc.length; i<len; i++) {
                        lc[i].select(".area").style("opacity", "0.3");
                        lc[i].select(".lineChartline").style("stroke-width", "2");
                        lc[i].selectAll(".lineDots").attr("r", 2.5);
                    }
                }

                function highlight(value) {
                    value = 'lc'+value.replace(/((?:\W))/g,"");
                    for (var i = 0, len = lc.length; i<len; i++) {
                        lc[i].select(".area").style("opacity", "0.1");
                        lc[i].select(".lineChartline").style("stroke-width", "0");
                        lc[i].selectAll(".lineDots").attr("r", 0);
                    }
                    for (var i = 0, len = lc.length; i<len; i++) {
                        if (lc[i][0][0].className.animVal === value) {
                            lc[i].select(".area").style("opacity", "1");
                        }
                    }
                }

                function getHour(time, last) {
                    if (last) {
                        return Math.ceil(time/interval)*interval*1000
                    }
                    return Math.floor(time/interval)*interval*1000
                }

                /////////////
                /// HOVER ///
                /////////////
                var ext = element[0].querySelector(".brush .background");

                var hoverBox, chv, hoverBoxText;
                var pagex, pagey, pageyOld, offsetx, boxWidth;
                var hoverValues, hoverChart;
                var hoverText = "";
                var divAtts = d3.select(element[0])[0][0];
                var offX = 0;
                var offXOld = 0;
                setMouseEvents();

                function setMouseEvents() {
                    if ($scope.main.dataObjects[key].group) {
                        divAtts = d3.select(element[0])[0][0];
                        hoverValues = $scope.main.dataObjects[key].group.top(Infinity);
                        d3.selectAll(".hoverChart").remove();
                        hoverChart = d3.select(".brush")
                            .insert("rect", ".extent")
                            .classed("hoverChart", true)
                            .attr("x", ext.x.animVal.value)
                            .attr("height", ext.height.animVal.value)
                            .attr("width", ext.width.animVal.value)
                            .attr('fill', 'transparent');
                        d3.select(".brush .extent").on('mouseenter',function(d) {
                            removeHover();
                        });

                        let hoverTime = 50;
                        let tempVal;
                        hoverChart.on('mousemove',function(d) {
                            hoverText = "";
                            pagey = d3.event.layerY+3;
                            offsetx = d3.event.offsetX+3;
                            waitForFinalEvent(function () {
                                setUpHover();
                                var temp;
                                for (var h = 0, len = hoverValues.length; h < len; h++ ) {
                                    if (moment(hoverValues[h].key).unix() == moment(getHour(Number(start) + (end-start)*(offsetx/ext.width.animVal.value))).unix()) {
                                        hoverText += "<strong class='hoverTitle'>Time: </strong>" + timeFormat(hoverValues[h].key, 'chartHover') +"<br/>";
                                        if ((toggleValues) && (typeof toggleValues !== "undefined")) {
                                            for (var v in hoverValues[h].value) {
                                                if ($scope.page.settings.get('toggleVal') === "KB") {
                                                    temp = String(v).replace("bytes", 'KB');
                                                } else if ($scope.page.settings.get('toggleVal') === "MB" ) {
                                                    temp = String(v).replace("bytes", 'MB');
                                                } else {
                                                    temp = v;
                                                }
                                                if (String(temp).split("(").length > 1) {
                                                    temp = String(temp).split("(")[0]+"... "
                                                } else {
                                                    temp = String(temp)
                                                }
                                                hoverText += "<span class='colorHover' style='background:"+colors(temp)+";'></span>";
                                                temp = String(temp).replace("_", ' ');
                                                hoverText += "<strong class='hoverTitle'>"+temp.replace("N/A", "-")+" : </strong>" + Math.round(hoverValues[h].value[v]/$scope.togVal * 100) / 100+"<br/>";
                                            }
                                        } else {
                                            for (var v in hoverValues[h].value) {
                                                if (v !== "other") {
                                                    if (String(v).split("(").length > 1) {
                                                        tempVal = String(v).split("(")[0]+"... "
                                                    } else {
                                                        tempVal = String(v)
                                                    }
                                                    hoverText += "<span class='colorHover' style='background:"+colors(tempVal)+";'></span><strong class='hoverTitle'>"+tempVal.replace("N/A", "-")+" : </strong>" + Math.round(hoverValues[h].value[v] * 100) / 100+"<br/>";
                                                }
                                            }
                                        }
                                    }
                                }
                                if (hoverText !== "") {
                                    offX = ((ext.width.animVal.value) / hours * ((moment(getHour(Number(start) + (end-start)*(offsetx/ext.width.animVal.value))).unix() - moment(getHour(Number(start))).unix())/interval));
                                    if (element[0].querySelector('.hoverNodes')) {
                                        if ((ext.width.animVal.value - offX) < element[0].querySelector('.hoverNodes').clientWidth) {
                                            boxWidth = divAtts.offsetLeft+margin.left-element[0].querySelector('.hoverNodes').clientWidth-6;
                                            boxWidth = divAtts.offsetLeft+margin.left-element[0].querySelector('.hoverNodes').clientWidth-6;
                                        } else {
                                            boxWidth = divAtts.offsetLeft+margin.left+3;
                                            boxWidth = divAtts.offsetLeft+margin.left+3;
                                        }
                                    }
                                    chv.style("left", (offX+divAtts.offsetLeft+margin.left)+"px");
                                    hoverBox.style("top", (pageyOld+3)+"px")
                                        .style("left", (offXOld+boxWidth)+"px")
                                        .transition()
                                        .duration(250)
                                        .style("top", (pagey+3)+"px")
                                        .style("left", (offX+boxWidth)+"px");
                                    hoverBoxText.html(hoverText);
                                    offXOld = offX;
                                    pageyOld = pagey;
                                } else {
                                    removeHover();
                                }
                            }, 50, "linecharthover");
                        });
                    }
                }
                d3.select(element[0]).on('mouseleave', function(d) {
                    waitForFinalEvent(function () {
                        removeHover();
                    }, 100, "linecharthover");
                });
                function setUpHover() {
                    removeHover(); // for when you highlight the hover info
                    hoverBox = d3.select("#"+attrs.id).append("xhtml:div").attr("class", "hoverNodes linehover").style("left", "0px").style("top", "0px").style("min-width", "100px");
                    chv = d3.select("#"+attrs.id).append("g").attr("class", "crosshair-v hair").style("left", "0px").style("top", (divAtts.offsetTop+margin.top)+"px").style("height", (divAtts.offsetHeight-margin.top-margin.bottom)+"px");
                    hoverBoxText = hoverBox.append("div").attr("class","hoverBoxText");
                }
                function removeHover() {
                    d3.selectAll(".hair").remove();
                    d3.selectAll(".hoverNodes").remove();
                    d3.selectAll(".hoverBoxText").remove();
                }

                ext = element[0].querySelector(".brush .background")

                function updateSlider(s, e) {
                    s = Math.max(s,bstart)
                    // e = Math.min(e,bend)
                    if (e > s) {
                        difference = ((e - s)/(bend - bstart));
                        if ((difference !== differenceOld)) {
                            ext = element[0].querySelector(".brush .extent")
                            if (ext) {
                                if (ext.width.animVal.valueAsString === "0") {
                                    ext = element[0].querySelector(".brush .background")
                                    brushExtent.attr("x", (ext.width.animVal.valueAsString - (ext.width.animVal.valueAsString*differenceOld)))
                                        .attr("y", ext.height.animVal.valueAsString)
                                        .attr("height", 5)
                                        .attr("width", (ext.width.animVal.valueAsString*differenceOld))
                                        .attr("fill", "#000")
                                        .attr("opacity", "0.5")
                                        .transition()
                                        .ease([0,0])
                                        .duration(100)
                                        .attr("x", (ext.width.animVal.valueAsString - (ext.width.animVal.valueAsString*difference)))
                                        .attr("width", (ext.width.animVal.valueAsString*difference));
                                }
                                else {
                                    let x = Number(ext.x.animVal.valueAsString) + Number(ext.width.animVal.valueAsString);
                                    brushExtent.attr("x", (x - (ext.width.animVal.valueAsString*differenceOld)))
                                        .attr("y", (ext.height.animVal.valueAsString - 5))
                                        .attr("height", 5)
                                        .attr("width", (ext.width.animVal.valueAsString*differenceOld))
                                        .attr("fill", "#000")
                                        .attr("opacity", "0.5")
                                        .transition()
                                        .ease([0,0])
                                        .duration(50)
                                        .attr("x", (x - (ext.width.animVal.valueAsString*difference)))
                                        .attr("width", (ext.width.animVal.valueAsString*difference));
                                }
                            }
                        }
                        differenceOld = difference;
                    }
                }

                var waitForFinalEvent = (function () {
                    var timers = {};
                    return function (callback, ms, uniqueId) {
                        if (!uniqueId) {
                            uniqueId = "linechartWait"; // don't call this twice without a uniqueId
                        }
                        if (timers[uniqueId]) {
                            clearTimeout (timers[uniqueId]);
                        }
                        timers[uniqueId] = setTimeout(callback, ms);
                    };
                })();

                function brushed() {
                    waitForFinalEvent(function () {
                        brushExtent.remove();
                        brushExtent = false;
                        difference = 0, differenceOld = 0;
                        brushExtent = brushDiv.append('rect').attr("class", "timeBrush");
                        $scope.page.complete = false;
                        let time
                        if (networkmap) {
                            $scope.$broadcast('outFilter', 'time', brush.extent());
                        } else {
                            if (Number(brush.extent()[0]) === Number(brush.extent()[1])) {
                                time = angular.copy($scope.main.getTime());
                                $scope.page.loadEnd = Number(time.end);
                                $scope.page.loadStart = Number(time.end);
                                bend = Number(time.end);
                                bstart = Number(time.start);
                                difference = 0, differenceOld = 0;
                            } else {
                                time = {
                                    start: Number(new Date(brush.extent()[0])/1000),
                                    end: Number(new Date(brush.extent()[1])/1000),
                                }
                                $scope.page.loadEnd = Number(time.end);
                                $scope.page.loadStart = Number(time.end);
                                bend = Number(time.end);
                                bstart = Number(time.start);
                            }
                            $scope.main.filterItemByTime(time);
                        }
                    }, 400, "linechartresize");
                }

                // set update functions
                $scope.$on('updatedData', function (event, id, startLoad) {
                    if ($scope.main.dataObjects[key].group) {
                        if (id !== uid) { return } // only run when it sees its id has filtered
                        setupData();
                        redrawAxis();
                        checkBoxValue();
                        redraw();
                        setMouseEvents();
                    }
                });

                $scope.$on('updateLoad', function (event, startLoad, minMultiple) {
                    if ($scope.main.dataObjects[key].group) {
                        if (minMultiple) {
                            $scope.page.loadStart = Math.min($scope.page.loadStart,startLoad);
                        } else {
                            $scope.page.loadStart = startLoad;
                        }
                        if (($scope.page.loadStart !== $scope.main.getTime().end) && (brushExtent)) {
                            updateSlider($scope.page.loadStart, $scope.page.loadEnd);
                        }
                    }
                });

                let resizeTimeout;
                $scope.page.w.bind('resize', function () {
                    if ( !resizeTimeout ) {
                        if (lineChartOn) {
                            resizeTimeout = setTimeout(function () {
                                resizeTimeout = null;
                                size = getSize(element, 'linechart');
                                width = size.width - margin.left - margin.right;
                                height = size.height
                                if (attrs.type === "services") {
                                    height = height/2;
                                }
                                height =  height - margin.top - margin.bottom;
                                d3.select(".brush .extent").attr("width", 0)
                                d3.select(".brush").attr("width", width)
                                d3.select(".brush .background").attr("width", width)
                                d3.select(".brush .hoverChart").attr("width", width)
                                brushDivRects.attr("height", height)
                                brushExtent.attr("height", height)
                                setWidthHeight(width, height);
                                redrawAxis();
                                redraw();
                                setMouseEvents()
                            }, 250);
                        }
                    }
                });

                $scope.$on('$destroy', function () {
                    lineChartOn = false;
                    removeHover();
                    element = null;
                    $scope.page.w = null;
                    resizeTimeout = true;
                });
            })
        }
    };
}

directive.$inject = ['getSize', '$location', 'generateId', 'timeFormat', '$window'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/linechart/makelinechart.js
 **/